import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[finderControlErrorClass]',
    standalone: true,
})
export class ControlErrorClassDirective implements OnChanges, OnDestroy {
    @Input() finderControlErrorClass = '';
    @Input() showError = false;
    @Input() controlError: FormControl;
    @Input() debounceTimeError: number;

    onDestroy$ = new Subject();

    constructor(private el: ElementRef) {
        this.onControlChanges();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.controlError?.firstChange && this.controlError) {
            this.onControlChanges();
        }
        if (
            changes.showError?.currentValue !==
            changes.showError?.previousValue
        ) {
            this.checkErrorClass();
        }
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    checkErrorClass() {
        const isInvalid = (this.showError || this.controlError.dirty) && !this.controlError.valid;
        if (!isInvalid) {
            this.el.nativeElement.classList.remove(this.finderControlErrorClass);

            return;
        }

        this.el.nativeElement.classList.add(this.finderControlErrorClass);
    }

    onControlChanges() {
        this.controlError?.valueChanges
            .pipe(
                debounceTime(this.debounceTimeError ?? 0),
                takeUntil(this.onDestroy$)
            ).subscribe(() => {
                this.checkErrorClass();
            });
    }
}
